import { experiment } from "@faire/web--source/common/settings/declarations/experiment";

/**
 * XP to change the filtered components to be 5m cache
 */
export const FE_FILTERED_COMPONENTS_5M_250408 = experiment({
  name: "FE_FILTERED_COMPONENTS_5M_250408",
  identifier: "RetailerTokenInSession",
  client: "RETAILER",
  notifyAfter: "2025-06-20",
  defaultValue: false,
  productArea: "CATEGORY_RESULTS",
});
